module.exports = __webpack_public_path__ + "img/icon5.c7ac9d10.svg";